<template>
	<div
		id="data-list-list-view"
		class="data-list-container"
	>
		<vs-popup
			class="holamundo"
			:title="modalType == 'edit' ? 'Ingatlan típus módosítása' : 'Új ingatlan típus'"
			:active.sync="propertyTypeModal"
		>
			<form
				data-vv-scope="propertyType"
				v-on:submit.prevent
			>
				<div class="vs-row">
					<vs-row>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-input
								label-placeholder="Név"
								v-model="propertyType.name"
								class="w-full mt-4"
								name="name"
								v-validate="'required'"
							/>
							<span class="text-danger">{{ errors.first('propertyType.name') }}</span>
						</vs-col>
						<vs-col
							vs-justify="left"
							vs-align="left"
							vs-w="12"
							class="p-2"
						>
							<vs-select
								class="w-full"
								label="Szülő"
								v-model="propertyType.parentId"
							>
								<vs-select-item
									key="0"
									value="null"
									text="[Nincs]"
								/>
								<vs-select-item
									v-for="propertyType in propertyTypes"
									:key="propertyType.id"
									:value="propertyType.id"
									:text="propertyType.name"
								/>
							</vs-select>
						</vs-col>
					</vs-row>
					<vs-row>
						<vs-col
							vs-w="6"
							class="p-2"
						>
							<vs-button
								class="mr-3 mb-2"
								@click="validate()"
							>Mentés</vs-button>
						</vs-col>
					</vs-row>
				</div>
			</form>
		</vs-popup>
		<div
			id="loading-bg"
			v-if="loading"
		>
			<div class="loading">
				<div class="effect-1 effects"></div>
				<div class="effect-2 effects"></div>
				<div class="effect-3 effects"></div>
			</div>
		</div>
		<vs-table
			v-model="selected"
			@selected="editData(selected)"
			pagination
			:hoverFlat="true"
			:notSpacer="true"
			:data="propertyTypes"
			v-if="propertyTypes"
		>

			<div
				slot="header"
				class="flex flex-wrap-reverse items-center flex-grow justify-between mb-6"
			>
				<div class="flex flex-wrap-reverse items-center data-list-btn-container">
					<!-- Input search -->
				</div>
				<div class="rounded-lg cursor-pointer items-center justify-center">
					<vs-button
						color="primary"
						size="large"
						class="pull-right btn-add-new"
						type="filled"
						icon-pack="feather"
						icon="icon-plus"
						@click="addNewData"
					>
						Új ingatlan típus
					</vs-button>
				</div>
			</div>

			<template slot="thead">
				<vs-th sort-key="firstName">Név</vs-th>
				<vs-th sort-key="lastName">Szülő</vs-th>
				<vs-th></vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
					<vs-tr
						:data="propertyType"
						:key="index"
						v-for="(propertyType, index) in data"
					>

						<vs-td>
							<p class="product-name font-medium truncate">{{ propertyType.name }}</p>
						</vs-td>

						<vs-td>
							<p class="product-category">{{ propertyType.parent ? propertyType.parent.name : '' }}</p>
						</vs-td>

						<vs-td class="whitespace-no-wrap">
							<div class="flex pull-right">
								<vx-tooltip text="Módosítás">
									<vs-button
										type="border"
										size="small"
										icon-pack="feather"
										icon="icon-edit"
										class="mr-2"
										color="dark"
										@click.stop="editData(propertyType)"
									></vs-button>
								</vx-tooltip>
								<vx-tooltip text="Törlés">
									<vs-button
										type="border"
										size="small"
										icon-pack="feather"
										icon="icon-trash-2"
										color="danger"
										class="mr-2"
										@click.stop="deleteData(propertyType.id)"
									></vs-button>
								</vx-tooltip>
							</div>
						</vs-td>

					</vs-tr>
				</tbody>
			</template>
		</vs-table>
	</div>
</template>

<script>
import { Validator } from 'vee-validate';

const dict = {
	custom: {
		name: {
			required: 'Név megadása kötelező.',
		}
	}
};
Validator.localize('en', dict);

export default {
	components: {
	},
	data() {
		return {
			selected: null,
			modalType: '',
			itemsPerPage: 10,
			isMounted: false,
			propertyTypes: null,
			loading: true,
			propertyTypeModal: false,
			parentId: '',
			propertyType: {
				name: '',
				parentId: ''
			}
		}
	},
	computed: {
		currentPage() {
			if (this.isMounted) {
				return this.$refs.table.currentx
			}
			return 0
		}

	},
	watch: {
	},
	methods: {
		fetch() {
			this.$http.get("/api/property-types/list/")
				.then((response) => {
					this.propertyTypes = response.data.data
					this.loading = false
				})
				.catch((error) => { console.log(error) })
		},
		addNewData() {
			this.modalType = 'create'
			this.propertyTypeModal = true
		},
		deleteData(id) {
			event.stopPropagation();
			this.$vs.dialog({
				type: 'confirm',
				color: 'danger',
				title: `Biztosan törlöd az adatot?`,
				acceptText: 'IGEN, törlöm',
				cancelText: 'mégsem',
				text: '',
				accept: this.confirmDelete,
				parameters: id
			})
		},
		confirmDelete(id) {
			this.$http.delete("/api/property-types/delete/" + id)
				.then(() => {
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres törlés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
					this.fetch();
				})
				.catch((error) => { console.log(error) })
		},
		editData(propertyType) {
			this.modalType = 'edit'
			this.propertyType = propertyType
			this.propertyTypeModal = true
		},
		validate() {
			return new Promise((resolve, reject) => {
				this.$validator.validateAll("propertyType").then(result => {
					if (result) {
						this.save()
						resolve(true)
					} else {
						reject("correct all values");
					}
				})
			})


		},
		save() {
			this.$vs.loading()
			var postMethod = ''
			switch (this.modalType) {
				case 'create':
					postMethod = 'create'
					break;

				case 'edit':
					postMethod = 'update/' + this.propertyType.id
					break;

				default:
					this.$vs.loading.close()
					this.$vs.notify({
						title: 'Hiba',
						text: 'Ismeretlen metódus',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'danger',
						position: 'bottom-center'
					})
					break;
			}

			this.$http.post("/api/property-types/" + postMethod, this.propertyType)
				.then(() => {
					this.$vs.loading.close()
					this.fetch();
					this.propertyType = {}
					this.propertyTypeModal = false
					this.$vs.notify({
						title: 'Siker',
						text: 'Sikeres mentés',
						iconPack: 'feather',
						icon: 'icon-alert-circle',
						color: 'success',
						position: 'bottom-center'
					})
				})

		}
	},
	created() {
		this.fetch()
	},
	mounted() {
		this.isMounted = true;
	}
}
</script>

<style lang="scss">
#data-list-list-view {
	.vs-con-table {
		/*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
		@media (max-width: 689px) {
			.vs-table--search {
				margin-left: 0;
				max-width: unset;
				width: 100%;

				.vs-table--search-input {
					width: 100%;
				}
			}
		}

		@media (max-width: 461px) {
			.items-per-page-handler {
				display: none;
			}
		}

		@media (max-width: 341px) {
			.data-list-btn-container {
				width: 100%;

				.dd-actions,
				.btn-add-new {
					width: 100%;
					margin-right: 0 !important;
				}
			}
		}

		.vs-table--header {
			display: flex;
			flex-wrap: wrap;
			margin-left: 0rem;
			margin-right: 0rem;
			> span {
				display: flex;
				flex-grow: 1;
			}

			.vs-table--search {
				padding-top: 0;

				.vs-table--search-input {
					padding: 0.9rem 2.5rem;
					font-size: 1rem;

					& + i {
						left: 1rem;
					}

					&:focus + i {
						left: 1rem;
					}
				}
			}
		}

		.vs-table {
			border-collapse: separate;
			border-spacing: 0rem;

			tr {
				box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
				td {
					padding: 20px;
				}
				td.td-check {
					padding: 20px !important;
				}
			}
		}

		.vs-table--thead {
			th {
				background-color: #fff;
				padding-top: 10;
				padding-bottom: 10;

				.vs-table-text {
					text-transform: uppercase;
					font-weight: 600;
				}
			}
			th.td-check {
				padding: 0 15px !important;
			}
			tr {
				background: none;
				box-shadow: none;
			}
		}

		.vs-table--pagination {
			justify-content: center;
		}
	}
}
</style>
